<ada-container
	horizontalSpacing="Medium"
	padding="{{ui.Spacing.SPACING_LARGE}}"
	verticalSpacing="Medium"
	[colCount]="4"
>
	<ada-alert
		*ngIf="errors.name | async as msg"
		[colSpan]="4"
		[isClosable]="false"
		[title]="msg"
		[type]="'Error'"
	></ada-alert>
	<ada-label
		content="Name"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
	></ada-label>
	<ada-input
		placeholder="Server name"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		[showAsFullWidth]="true"
		[value]="context.name"
		(valueChange)="updateName($event)"
	></ada-input>
	<ada-label
		content="Description"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
	></ada-label>
	<ada-input
		placeholder="Server description"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		[showAsFullWidth]="true"
		[type]="'Textarea'"
		[(value)]="context.description"
	></ada-input>
	<ada-alert
		*ngIf="errors.serverGuid | async as msg"
		[colSpan]="4"
		[isClosable]="false"
		[title]="msg"
		[type]="'Error'"
	></ada-alert>
	<ada-label
		content="Server GUID"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
	></ada-label>
	<ada-input
		placeholder="Server GUID"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		[showAsFullWidth]="true"
		[(value)]="context.serverGuid"
	></ada-input>
	<ada-alert
		*ngIf="errors.fqdn | async as msg"
		[colSpan]="4"
		[isClosable]="false"
		[title]="msg"
		[type]="'Error'"
	></ada-alert>
	<ada-label
		content="FQDN / IP Address"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
	></ada-label>
	<ada-input
		placeholder="FQDN / IP Address"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		[showAsFullWidth]="true"
		[(value)]="context.fqdn"
	></ada-input>
	<ada-alert
		*ngIf="errors.geolocation | async as msg"
		[colSpan]="4"
		[isClosable]="false"
		[title]="msg"
		[type]="'Error'"
	></ada-alert>
	<ada-vector2
		xLabel="Longitude"
		xLabelInfo="Supply a longitude value between -180 and 180"
		yLabel="Latitude"
		yLabelInfo="Supply a latidude value between -90 and 90"
		[colSpan]="4"
		[max]="geolocationMax"
		[min]="geolocationMin"
		[value]="geolocation"
		(valueChange)="setGeolocation($event)"
	></ada-vector2>
</ada-container>
